module.exports = __webpack_public_path__ + "static/img/Header_1920x380_gene-blog.eddcd30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/Header_1920x380_gene-blog.jpg
// module id = 13Fu
// module chunks = 0